import XReactionFooter from './sections/ReactionFooter'
import XDateType from './sections/DateType'
import XCTABanner from './sections/CTABanner'

export default {
  components: {
    XReactionFooter,
    XDateType,
    XCTABanner
  },

  props: {
    reaction: {
      type: Object,
      default: () => ({
        data: {}
      })
    },
    shareChannels: {
      type: Array
    },
    shareMessage: {
      type: String
    },
    shareHashtags: {
      type: Array
    },
    shareDescription: {
      type: String
    },
    showDateType: {
      type: Boolean,
      default: false
    },
    allowExpressions: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    showExpressions () {
      if (this.reaction.data && this.reaction.data.design) {
        return this.allowExpressions && this.reaction.data.design.showExpressions
      }

      return this.allowExpressions
    },

    showShare () {
      if (this.reaction.data && this.reaction.data.design) {
        return this.reaction.data.design.showShare
      }

      return true
    }
  },

  methods: {
    labelIcon (icon) {
      let label = ''
      switch (icon) {
        case 'fa/light/image' :
          label = this.$t('event.timeline.labels.images')
          break
        case 'fa/light/play' :
          label = this.$t('event.timeline.labels.videos')
          break
        case 'fa/regular/gift-card' :
          label = this.$t('event.timeline.labels.gifts')
          break
        case 'fa/light/file-alt' :
          label = this.$t('event.timeline.labels.files')
          break
        case 'fa/light/file-download' :
          label = this.$t('event.timeline.labels.downloads')
          break
        case 'others/gif' :
          label = this.$t('event.timeline.labels.gifs')
          break
        case 'fa/light/bullhorn' :
          label = this.$t('event.timeline.labels.announces')
          break
      }
      return label
    }
  }
}
